"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M15.448 12.78l4.474-1.163c1.513-.393 2.396-1.96 1.972-3.498-.41-1.486-1.89-2.403-3.354-2.109-.484-1.446-2-2.3-3.462-1.92-1.513.393-2.396 1.96-1.972 3.498l1.32 4.786A7.995 7.995 0 0012 12c-.846 0-1.66.131-2.426.374l1.32-4.786c.424-1.539-.46-3.105-1.972-3.498-1.463-.38-2.978.474-3.461 1.92-1.465-.294-2.945.623-3.355 2.11-.424 1.538.46 3.104 1.972 3.497l4.474 1.162A8 8 0 004 20h2.286a5.714 5.714 0 0111.428 0H20a8 8 0 00-4.552-7.22z\" fill=\"#1B1B22\"></path><path d=\"M11 18a1 1 0 11-2 0 1 1 0 012 0zM14 19a1 1 0 100-2 1 1 0 000 2z\" fill=\"#1B1B22\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;